'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherXCircle } from '@subframe/core';
import { useEffect, useState } from 'react';
import { Button, Dialog, TextArea } from '@/shared/components/ui';
import type { TrialTenant } from '../types';
import { formatarDataCurta } from '../utils/trialDateUtils';
interface EncerrarTrialModalProps {
  isOpen: boolean;
  trial: TrialTenant | null;
  saving: boolean;
  onClose: () => void;
  onConfirm: (motivo: string | null) => void;
}
export function EncerrarTrialModal(t0) {
  const $ = _c(45);
  const {
    isOpen,
    trial,
    saving,
    onClose,
    onConfirm
  } = t0;
  const [motivo, setMotivo] = useState("");
  const [ciente, setCiente] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isOpen) {
    t1 = () => {
      if (isOpen) {
        setMotivo("");
        setCiente(false);
      }
    };
    t2 = [isOpen];
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!trial) {
    return null;
  }
  const podeConfirmar = ciente && !saving;
  let t3;
  if ($[3] !== motivo || $[4] !== onConfirm || $[5] !== podeConfirmar) {
    t3 = () => {
      if (!podeConfirmar) {
        return;
      }
      onConfirm(motivo.trim() ? motivo.trim() : null);
    };
    $[3] = motivo;
    $[4] = onConfirm;
    $[5] = podeConfirmar;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleConfirm = t3;
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="bg-error-50 flex h-10 w-10 shrink-0 items-center justify-center rounded-full"><FeatherXCircle className="text-error-600 h-5 w-5" /></div>;
    t5 = <h2 className="text-body-bold font-body-bold text-default-font">Encerrar trial</h2>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  const t6 = trial.tenantNome;
  let t7;
  if ($[9] !== trial.dataExpiracao) {
    t7 = formatarDataCurta(trial.dataExpiracao);
    $[9] = trial.dataExpiracao;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7 || $[12] !== trial.tenantNome) {
    t8 = <div className="flex items-start gap-3">{t4}<div>{t5}<p className="text-caption font-caption text-subtext-color mt-1">{t6} · expira em {t7}</p></div></div>;
    $[11] = t7;
    $[12] = trial.tenantNome;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="border-error-200 bg-error-50 flex items-start gap-3 rounded-[8px] border px-4 py-3 text-sm"><FeatherAlertTriangle className="text-error-600 mt-0.5 h-4 w-4 shrink-0" /><div><p className="text-error-700 font-semibold">O acesso será bloqueado imediatamente após o encerramento.</p><p className="text-error-700 mt-0.5">Esta ação é definitiva e irreversível.</p></div></div>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <label className="text-sm font-medium text-neutral-700">Motivo do encerramento{" "}<span className="font-normal text-neutral-400">(opcional)</span></label>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = event => setMotivo(event.target.value);
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== motivo) {
    t12 = <div className="flex flex-col gap-1.5">{t10}<TextArea><TextArea.Input placeholder="Descreva o motivo do encerramento..." value={motivo} onChange={t11} rows={3} /></TextArea></div>;
    $[17] = motivo;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = event_0 => setCiente(event_0.target.checked);
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== ciente) {
    t14 = <input type="checkbox" checked={ciente} onChange={t13} className="accent-error-600 mt-0.5 h-4 w-4 rounded border-neutral-300" />;
    $[20] = ciente;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="text-sm text-neutral-700">Estou ciente que esta ação é{" "}<span className="font-semibold">irreversível e bloqueia o acesso do cliente</span>{" "}imediatamente.</span>;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t14) {
    t16 = <label className="flex cursor-pointer items-start gap-3">{t14}{t15}</label>;
    $[23] = t14;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="flex items-start gap-2 rounded-[8px] bg-neutral-50 px-3 py-2 text-xs text-neutral-600">Após encerrar, este cliente só poderá ter novo trial com aprovação explícita de um Admin.</div>;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== onClose || $[27] !== saving) {
    t18 = <Button variant="neutral-secondary" size="medium" onClick={onClose} disabled={saving}>Cancelar</Button>;
    $[26] = onClose;
    $[27] = saving;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  const t19 = !podeConfirmar;
  let t20;
  if ($[29] !== handleConfirm || $[30] !== saving || $[31] !== t19) {
    t20 = <Button variant="destructive-primary" size="medium" onClick={handleConfirm} loading={saving} disabled={t19}>Encerrar trial</Button>;
    $[29] = handleConfirm;
    $[30] = saving;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t18 || $[34] !== t20) {
    t21 = <div className="flex items-center justify-end gap-2 border-t border-neutral-100 pt-4">{t18}{t20}</div>;
    $[33] = t18;
    $[34] = t20;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t12 || $[37] !== t16 || $[38] !== t21 || $[39] !== t8) {
    t22 = <Dialog.Content className="max-w-md"><div className="flex w-full flex-col gap-5 p-6">{t8}{t9}{t12}{t16}{t17}{t21}</div></Dialog.Content>;
    $[36] = t12;
    $[37] = t16;
    $[38] = t21;
    $[39] = t8;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== isOpen || $[42] !== onClose || $[43] !== t22) {
    t23 = <Dialog open={isOpen} onOpenChange={onClose}>{t22}</Dialog>;
    $[41] = isOpen;
    $[42] = onClose;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  return t23;
}